<!-- eslint-disable vue/multi-word-component-names -->
 <template>
  <svg :class="svgClass" v-bind="svgAttrs" :style="{ color: color }">
    <title v-if="svgTitle">{{ svgTitle }}</title>
    <use :xlink:href="iconName" />
  </svg>
</template>

<script setup>
import { defineProps, computed, useAttrs } from "vue";

const attrs = useAttrs();

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "",
  },
});

const iconName = computed(() => `#icon-${props.name}`);
const svgTitle = computed(() => String(attrs.title || "").trim());
const svgAttrs = computed(() => {
  const { title, ...rest } = attrs;
  return rest;
});
const svgClass = computed(() => {
  if (props.name) {
    return `svg-icon icon-${props.name}`;
  }
  return "svg-icon";
});
</script>

<style lang='scss'>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: middle;
}
</style>